'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFlagByCurrency = getFlagByCurrency;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFlagByCurrency(currencyId) {
    switch (currencyId) {
        case constants.RUB:
            return _react2.default.createElement('span', { className: 'fa fa-rub' });
            break;
        case constants.EUR:
            return _react2.default.createElement('span', { className: 'fa fa-eur' });
            break;
        case constants.USD:
            return _react2.default.createElement('span', { className: 'fa fa-usd' });
            break;
        case constants.GBP:
            return _react2.default.createElement('span', { className: 'fa fa-gbp' });
            break;
        case constants.UAH:
            return _react2.default.createElement(
                'span',
                { className: 'ukr' },
                '\u20B4'
            );
            break;
        case constants.MDL:
            return _react2.default.createElement(
                'span',
                { className: 'mdl' },
                'L'
            );
            break;
        case constants.BYN:
            return _react2.default.createElement(
                'span',
                { className: 'byn' },
                'L'
            );
            break;
        case constants.TRY:
            return _react2.default.createElement(
                'span',
                { className: 'try' },
                '\u20BA'
            );
            break;
        case constants.AED:
            return _react2.default.createElement(
                'span',
                { className: 'try' },
                'Dh'
            );
            break;
        case constants.SGD:
            return _react2.default.createElement(
                'span',
                { className: 'sgd' },
                'S$'
            );
            break;
        case constants.UZS:
            return _react2.default.createElement(
                'span',
                { className: 'sgd' },
                '\u0441\u045E\u043C'
            );
            break;
        default:
            return null;
            break;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/components/AmountFormat/currenciesTools.js
// module id = 1601
// module chunks = 0